import PhotographerBookingApi from '../SE360PhotographerBookingApi';
import ICoordinate from '../../../map/ICoordinate';
import * as types from './SE360ActionTypes';
import { handleError } from '../../../../shared/ErrorCatching';

function getPhotographerBookingSuccess(result: any) {
    return { type: types.SE360_GET_PHOTOGRAPHERBOOKING_SUCCESS, result };
}

export function getPhotographerCalendars(
    date: Date,
    orderId: number,
    regionId?: number,
    isAdvanceMode?: boolean,
    executionTime?: number,
    includeTraveltimes?: boolean
) {
    return (dispatch: (result: any) => void) =>
        PhotographerBookingApi.getPhotographerCalendars(
            date,
            orderId,
            regionId,
            isAdvanceMode,
            executionTime,
            includeTraveltimes
        ).then((result: any) => {
            dispatch(getPhotographerBookingSuccess(result));
            dispatch(getLocationData(date, null, null, orderId));
            return result;
        });
}

function getLocationDataSuccess(result: any) {
    return { type: types.SE360_GET_LOCATIONDATA_SUCCESS, result };
}

function getLocationDataFailure(error: any) {
    return { type: types.SE360_GET_LOCATIONDATA_ERROR, error };
}

function getLocationData(date: Date, lat?: number, lon?: number, orderId?: number) {
    return (dispatch: (result: any) => void) =>
        PhotographerBookingApi.getLocationData(date.toISOString().substr(0, 10), orderId, lat, lon)
            .then((result: any) => {
                dispatch(getLocationDataSuccess(result));
                return result;
            })
            .catch((error: any) => {
                dispatch(getLocationDataFailure(error));
                handleError(error);
            });
}

export function getphotographersForNewBooking(
    date: Date,
    address: string,
    postalCode: string,
    city: string,
    executionTime: number,
    productIds: number[],
    brokerFirmId: number,
    numberOfMeasuredPlans?: number,
    lat?: number,
    lon?: number
) {
    return (dispatch: (result: any) => void) =>
        PhotographerBookingApi.getphotographersForNewBooking(
            date,
            address,
            postalCode,
            city,
            executionTime,
            productIds,
            brokerFirmId,
            numberOfMeasuredPlans,
            lat,
            lon
        ).then((result: any) => {
            dispatch(getPhotographerBookingSuccess(result));
            dispatch(getLocationData(date, lat, lon));
            return result;
        });
}

export function updatePhotographer(data: any) {
    return (dispatch: (result: any) => void) =>
        PhotographerBookingApi.updatePhotographerCalendar(data);
}

function saveAddressPointLocationForBookingSuccess(addressPointLocation: ICoordinate) {
    return {
        type: types.SAVE_ADDRESS_POINT_LOCATION_FOR_BOOKING_SUCCESS,
        result: addressPointLocation
    };
}

export function saveAddressPointLocationForBooking(addressPointLocation: ICoordinate) {
    return (dispatch: (result: any) => void) =>
        dispatch(saveAddressPointLocationForBookingSuccess(addressPointLocation));
}

function clearAddressPointLocationForBookingSuccess() {
    return { type: types.CLEAR_ADDRESS_POINT_LOCATION_FOR_BOOKING_SUCCESS };
}

export function clearAddressPointLocationFroBooking() {
    return (dispath: (result: any) => void) =>
        dispath(clearAddressPointLocationForBookingSuccess());
}

export function getAddressCoordinates(address: string, postalCode: string, city: string) {
    return (dispatch: (result: any) => void) =>
        PhotographerBookingApi.getAddressCoordinates(address, postalCode, city).then(
            (result: any) => {
                return result;
            }
        );
}
